import { PublicKey, TransactionInstruction } from '@solana/web3.js'

export const TOKEN_PROGRAM_ID = new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')
export const ASSOCIATED_TOKEN_PROGRAM_ID = new PublicKey(
	'ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL'
)
const SYSTEM_PROGRAM_ID = new PublicKey('11111111111111111111111111111111')

export function getAssociatedTokenAddress(mint: PublicKey, owner: PublicKey): PublicKey {
	const [address] = PublicKey.findProgramAddressSync(
		[owner.toBuffer(), TOKEN_PROGRAM_ID.toBuffer(), mint.toBuffer()],
		ASSOCIATED_TOKEN_PROGRAM_ID
	)
	return address
}

/**
 * Build a raw SPL Token transfer instruction (no @solana/spl-token import
 * needed). Layout: 1-byte instruction index (3 = Transfer) + 8-byte LE amount.
 */
export function createSplTransferInstruction(
	source: PublicKey,
	destination: PublicKey,
	owner: PublicKey,
	amount: bigint
): TransactionInstruction {
	const data = Buffer.alloc(9)
	data.writeUInt8(3, 0)
	let remaining = amount
	for (let i = 0; i < 8; i++) {
		data[1 + i] = Number(remaining & 0xffn)
		remaining >>= 8n
	}

	return new TransactionInstruction({
		keys: [
			{ pubkey: source, isSigner: false, isWritable: true },
			{ pubkey: destination, isSigner: false, isWritable: true },
			{ pubkey: owner, isSigner: true, isWritable: false },
		],
		programId: TOKEN_PROGRAM_ID,
		data,
	})
}

/**
 * Build the "create associated token account" instruction so the recipient
 * can receive SPL tokens even if they've never held any.
 */
export function createAssociatedTokenAccountInstruction(
	payer: PublicKey,
	associatedToken: PublicKey,
	owner: PublicKey,
	mint: PublicKey
): TransactionInstruction {
	return new TransactionInstruction({
		keys: [
			{ pubkey: payer, isSigner: true, isWritable: true },
			{ pubkey: associatedToken, isSigner: false, isWritable: true },
			{ pubkey: owner, isSigner: false, isWritable: false },
			{ pubkey: mint, isSigner: false, isWritable: false },
			{ pubkey: SYSTEM_PROGRAM_ID, isSigner: false, isWritable: false },
			{ pubkey: TOKEN_PROGRAM_ID, isSigner: false, isWritable: false },
		],
		programId: ASSOCIATED_TOKEN_PROGRAM_ID,
		data: Buffer.alloc(0),
	})
}
